export default class WechatAuth{
    config = {};

    constructor(config = {}) {
        this.config = {
            appId: process.env.VUE_APP_WECHAT_APP_ID,
            responseType: 'code',
            scope: 'snsapi_userinfo',
            ...config
        };
    }

    auth(redirect) {
        sessionStorage.setItem('login_redirect', redirect);
        redirect = window.location.origin + '/login';
        // console.log(redirect);
        const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.config.appId}&redirect_uri=${redirect}&response_type=code&scope=${this.config.scope}&state=STATE#wechat_redirec`
        window.location.replace(authUrl);
    }
}